import React from 'react';
import _ from 'lodash';
//import renderIf from '../../../../pkgs/render_if';

import {
  FormControl,
} from 'react-bootstrap';

export default class IntField extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            errors: false,
            touched_and_blank: false,
            value: null,
            class_names: '',
        }
    }

    componentDidMount = () => {
        //console.log('CharField componentDidMount');
        this.setState({value: this.props.editingInstance[this.props.field_id]});
        if (this.props.focus === this.props.field_id) {
            $(`#${this.props.field_id}`).focus();
        }
    }

    onChange = (e) => {
        if (this.setErrorTimer) {
            clearTimeout(this.setErrorTimer);
        }
        let data_key = e.target.name;
        //let key = data_key.toLowerCase().replace(/ /g,"_");
        let key = this.props.field_id;
        let value = $.trim(e.target.value);
        //If its not a number, create an error
        //console.log('Value: ' + value)
        if (value) {
            if (!isNaN(value)) {
                //console.log('Success, This is a number!');
                this.setState({
                  errors: false,
                  class_names: '',
                  touched_and_blank: false,
                  value: value,
                });
                this.setErrorTimer = setTimeout(() => {
                  this.props.onSelectChange(key, value);
                }, 100);
            }
            //this.props.onHandleSuccess(key);
          // } else {
          //   //console.log('Error, this not a number!')
          //   //this.props.onHandleErrors(key);
          //   this.setState({
          //     errors: true,
          //     class_names: 'error',
          //     touched_and_blank: false,
          //   });
          // }
        }
        // if (!value && this.props.field_required === true) {
        //   //console.log('This field is required but there is no value.')
        //   this.props.onHandleErrors(key);
        //   this.setState({
        //     errors: false,
        //     class_names: 'error',
        //     touched_and_blank: true,
        //   });
        // }
    }

    // handleBlur = () => {
    //   if (this.props.field_required === true && !this.state.value) {
    //     this.props.onHandleErrors(this.props.data_key);
    //     this.setState({touched_and_blank: true, class_names: 'error'});
    //   }
    // }

    render() {
        let placeholder = this.props.field_placeholder;
        return (
            <div>
                  <FormControl
                    type='text'
                    value={this.state.value}
                    name={this.props.field_id}
                    id={`${this.props.field_id}`}
                    onChange={this.onChange}
                    placeholder={placeholder}
                  />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/int_field.js